export const paymentProcess = async (type, value, setAmount, amount, cart, tillData, selectedPaymentMethod, setOverPayedAmount, setNumb, numb) => {
  const currenciesList = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];

  const precision = tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2;

  /* -------------------------------------------------- */
  /* SAFE NUMERIC SETTER (for calculations only)       */
  /* -------------------------------------------------- */
  const safeSetNumericAmount = (val) => {
    const num = Number(val);
    if (!isNaN(num) && isFinite(num)) {
      setAmount(num);
    }
  };

  /* -------------------------------------------------- */
  /* Rounding Logic                                     */
  /* -------------------------------------------------- */
  const calculateRoundingDifference = (enteredAmount) => {
    if (selectedPaymentMethod?.roundOffForPos !== "Y") {
      setOverPayedAmount(0);
      return;
    }

    const remainingAmount = Math.abs(cart.total) - (cart.paid ?? 0);

    const smallestDenomination = currenciesList.length > 0 ? currenciesList[0].value : 1;

    if (enteredAmount < remainingAmount) {
      setOverPayedAmount(0);
      return;
    }

    const roundedAmount = Math.ceil(remainingAmount / smallestDenomination) * smallestDenomination;

    const overpayment = (roundedAmount - remainingAmount).toFixed(precision);

    setOverPayedAmount(parseFloat(overpayment) > 0 ? overpayment : 0);
  };

  /* ================================================== */
  /* TYPE 1 → KEYPAD INPUT (STRING BASED)              */
  /* ================================================== */
  if (type === "1") {
    if (tillData.tillAccess.cwrTill.layAway === "Y" && tillData.tillAccess.cwrTill.payNow === "N") {
      return null;
    }

    if (amount === "" && value === "x") {
      setAmount("");
      return;
    }

    // Backspace
    if (value === "x") {
      const newAmount = amount.toString().slice(0, -1);
      setAmount(newAmount);

      const numericVal = Number(newAmount);
      if (!isNaN(numericVal) && selectedPaymentMethod?.name?.toLowerCase() === "cash" && numericVal >= Math.abs(cart.total) - (cart.paid ?? 0)) {
        calculateRoundingDifference(numericVal);
      } else {
        setOverPayedAmount(0);
      }
      return;
    }

    // Normal typing
    if (Object.keys(selectedPaymentMethod || {}).length > 0) {
      if (numb === 0) {
        setNumb(1);
        setAmount(value); // keep as string for decimals
      } else {
        const newAmount = `${amount}${value}`;
        setAmount(newAmount); // keep string while typing
      }

      const numericVal = Number(numb === 0 ? value : `${amount}${value}`);

      if (!isNaN(numericVal) && selectedPaymentMethod?.name?.toLowerCase() === "cash" && numericVal >= Math.abs(cart.total) - (cart.paid ?? 0)) {
        calculateRoundingDifference(numericVal);
      } else {
        setOverPayedAmount(0);
      }
    }
  } else if (type === "2") {

  /* ================================================== */
  /* TYPE 2 → QUICK ADD AMOUNT (NUMERIC SAFE)          */
  /* ================================================== */
    const baseAmount = Number(amount !== "" ? amount : 0);
    const addValue = Number(value);

    if (isNaN(addValue)) return;

    const finalAmount = numb === 0 ? addValue : parseFloat((baseAmount + addValue).toFixed(precision));

    if (numb === 0) setNumb(1);

    safeSetNumericAmount(finalAmount);

    if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && finalAmount >= Math.abs(cart.total) - (cart.paid ?? 0)) {
      calculateRoundingDifference(finalAmount);
    } else {
      setOverPayedAmount(0);
    }
  } else if (type === "3") {

  /* ================================================== */
  /* TYPE 3 → DIRECT ENTRY (NUMERIC SAFE)              */
  /* ================================================== */
    const enteredValue = Number(value);
    if (isNaN(enteredValue)) return;

    const cashTotal = cart.payments.reduce((total, item) => parseFloat(total) + parseFloat(item.amount), 0);

    const finalAmount = enteredValue + cashTotal;

    if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && finalAmount >= Math.abs(cart.total) - (cart.paid ?? 0)) {
      calculateRoundingDifference(finalAmount);
    } else {
      setOverPayedAmount(0);
    }

    safeSetNumericAmount(enteredValue);
  }
};
